// extracted by mini-css-extract-plugin
export var container = "contact-form-module--container--XpATq";
export var disclaimerText = "contact-form-module--disclaimer-text--pnvlS";
export var errorText = "contact-form-module--error-text--TPGnH";
export var form = "contact-form-module--form--CoO8-";
export var inputs = "contact-form-module--inputs--S3m+K";
export var successMessage = "contact-form-module--success-message--4FMHZ";
export var titleText = "contact-form-module--title-text--gnnfl";